/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";

/*------------------------------------*\
    NAVIGATION MODULE
\*------------------------------------*/
class Navigation {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        self.navigationBtn = document.querySelector('.site-head__button');
        self.navigationBrand = document.querySelector('.site-head__nav-brand');
        self.navigationFullWidth = document.querySelector('.site-head__full-width-menu');
        self.navigationList = document.querySelector('.site-head__nav-list');
        self.navigationListSecondary = document.querySelector('.site-head__nav-list-secondary');

        function changeExpandedState() {
            let stateNav = false;

            if (self.navigationBtn.getAttribute("aria-expanded") == 'false') {
                stateNav = true;
            }

            self.navigationBtn.setAttribute("aria-expanded", stateNav);
            self.navigationBrand.setAttribute("aria-expanded", stateNav);
            self.navigationFullWidth.setAttribute("aria-expanded", stateNav);
            self.navigationList.setAttribute("aria-expanded", stateNav);
            self.navigationListSecondary.setAttribute("aria-expanded", stateNav);

            self.addDelays(stateNav);
            self.bodyScroll(stateNav);
        }

        self.navigationBtn.addEventListener("click", changeExpandedState);
    }

    bodyScroll(stateNav) {
        if (stateNav) {
            document.body.classList.add("no-scroll");
        } else {
            document.body.classList.remove("no-scroll");
        }
    }

    addDelays(stateNav) {
        let self = this;
        let delay = 0;

        if (stateNav) {
            delay = 0.3;
        }

        $(self.navigationListSecondary).find('li').each(function() {
            $(this).css('animation-delay', delay + 's');
            console.log(delay.toFixed(1));
            delay += 0.025;
        })
    }
}

export default Navigation;
